import { usePerms } from 'contexts/PermsContext';
import { FEMA_PERMISSIONS } from 'features/Weather/features/WeatherAlerts/features/AlertCreator/components/IpawsAlertFields/config/Ipaws.config';
import FemaAlertList from 'features/Weather/features/WeatherAlerts/features/FemaAlertList/index.web';
import { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

/**
 * The FEMA message list page (card FE-04): the workplace's own thread of every FEMA message it
 * sent, gated on `ViewFemaAlerts` — separate from the RescAlert weather alerts page and its
 * widget, which this page does not touch.
 */
const FemaAlerts = () => {
  const perms = usePerms();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      if (!(await perms.validatePermissions([FEMA_PERMISSIONS.view]))) {
        navigate('/404');
        return;
      }
    })();
  }, [navigate, perms]);

  if (!perms.testPermission([8, 9, 10, 11, 12, 13], [FEMA_PERMISSIONS.view])) return null;

  return (
    <Container fluid className="py-3">
      <div style={{ height: 'calc(100% - 20px)' }}>
        <FemaAlertList title="FEMA Alerts" perms={perms} />
      </div>
    </Container>
  );
};

export default FemaAlerts;

